export default __webpack_public_path__ + "static/media/DOB.b1a1e9f8.svg";